const PRODUCTS_CONSTANTS = {
  PRODUCTS: 'Products',
  CREATE_PRODUCT: 'CreateProduct',
  VIEW_PRODUCT: 'ViewProduct/:productUID',
};
export default PRODUCTS_CONSTANTS;
